import { filter } from 'lodash';
import * as t from './actionTypes';

const initialState = {
    loadingIncidents: true,
    loadingDetails: true,
    incidents: [],
    selectedYear: new Date().getFullYear(),
    selectedDetailIncident: {},
    selectedDetailIncidentIsDirty: false,
}

export default function (state = initialState, action) {
    switch (action.type) {
        case t.LOAD_INCIDENTS:
            return Object.assign({}, state, {
                incidents: action.payload
            });
        case t.DETAILS_LOADING:
            return Object.assign({}, state, {
                loadingDetails: action.payload,
            });
        case t.LOAD_INCIDENTDETAILS:
            return Object.assign({}, state, {
                selectedDetailIncident: action.payload,
                selectedDetailIncidentIsDirty: false
            });
        case t.INCIDENTS_LOADING:
            return Object.assign({}, state, {
                loadingIncidents: action.payload,
            });
        case t.SET_INCIDENTS_SELECTEDYEAR:
            return Object.assign({}, state, {
                selectedYear: action.payload
            });
        case t.SET_SELECTED_DETAIL_INCIDENT_DIRTY:
            return Object.assign({}, state, {
                selectedDetailIncidentIsDirty: action.payload
            });
        default:
            return state
    }
}